export default "<span class=\"text\">\n    <ng-content></ng-content>\n</span>\n";